import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Stack } from '@mui/system';
import React, { useState, useEffect, useCallback } from 'react';
import ContainedButton from '../../components/actions/ContainedButton';
import ErrorAlert from '../../components/alerts/ErrorAlert';
import BaseModal from '../../components/modals/BaseModal';
import useUser from '../../hooks/api/useUser';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { updateProgram2Client, updateUserClientProgram } from '../../services/clientProgramService';
import { catalogs } from '../../utils/catalogs';
import { onGetFullname, sleep } from '../../utils/general';
import { useBoolean } from '../../hooks/useBoolean';
import LoadingContainer from '../../components/loaders/LoadingContainer';

const validationSchema = Yup.object().shape({
    user_client_program_status_id: Yup.number().required('Debe seleccionar un estatus')
});

const EditClientProgramStatusModal = ({
    open, onClose, onRefresh, origin
}) => {

    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const loading = useBoolean()

    const methods = useForm({
        resolver: yupResolver(validationSchema),
    });
    const { register, control, setValue, getValues, reset, handleSubmit, formState:{errors} } = methods


    useEffect(() => {
        if(open && origin) onInitModule()
    },[open])

    const onInitModule = useCallback(async() => {
        loading.onTrue()
        //await sleep(1000)
        reset()
        console.log()
        setValue("user_client_program_status_id", origin?.user_client_program_status_id ?? "")
        loading.onFalse()
    }, [origin])

    const onSubmit = async(data) => {
        console.log(data)

       
        setSending(true)

        try {
            await updateUserClientProgram(origin?.id_user_client_program, data)
            await onRefresh()
        } catch (error) {
            setError(error)
            setSending(false)
            return
        }

        setSending(false)
        onClose()

    }

    const userdata = {
        first_name:origin?.user_first_name,
        fathers_last_name:origin?.user_fathers_last_name,
        mothers_last_name:origin?.user_mothers_last_name,
    }

    return ( 
        <BaseModal maxWidth='sm'
        title='Modificar estatus del paciente'
        open={open} 
        onClose={onClose} >
            <div>
                <Typography><strong>Paciente: </strong> {onGetFullname(userdata)}</Typography>
                <Stack spacing={2}>
                    <LoadingContainer loading={loading.value}>
                        <Stack spacing={0}>
                            <Typography variant='subtitle2' sx={{paddingBottom:2}}>Seleccione el estatus del paciente</Typography>
                            <Controller
                                control={control}
                                name="user_client_program_status_id"
                                render={({ field }) => {
                                    return (
                                        <TextField
                                            select
                                            value={field.value}
                                            inputRef={field.ref}
                                            onChange={(data) => {
                                                field.onChange(data);
                                            }}
                                            error={!!errors?.user_client_program_status_id}
                                            helperText={errors?.user_client_program_status_id?.message}  
                                            fullWidth                                          
                                        >
                                        {catalogs.user_client_program_statuses.map(item => {
                                            return(
                                                    <MenuItem value={item.value} key={item.value}>
                                                        {item.label}
                                                    </MenuItem>
                                                )
                                            })}
                                        </TextField>
                                    )
                                }}
                            />
                        </Stack>
                    </LoadingContainer>
                    {error && 
                        <Grid item xs={12}>
                            <ErrorAlert 
                            error={error} 
                            onClose={() => setError(null)} />
                        </Grid> 
                    }
                    <Stack direction='row' justifyContent='flex-end' >
                        <ContainedButton  loading={sending} onClick={handleSubmit(onSubmit)}>
                            Guardar
                        </ContainedButton>
                    </Stack>
                        
                    </Stack>
                    
                </div>
        </BaseModal>
     );
}

 
export default EditClientProgramStatusModal;